import { STAGE_HEIGHT, STAGE_WIDTH } from '../config/kiosk'

/**
 * Scales the fixed 1080x1920 stage to fit the actual viewport.
 *
 * On the kiosk this resolves to scale(1) with no offset. In a desktop dev
 * browser it letterboxes, so what you see is geometrically identical to the
 * panel — no "looks fine on my laptop" surprises.
 */
export function mountStage(stage: HTMLElement): () => void {
  const apply = (): void => {
    const vw = window.innerWidth
    const vh = window.innerHeight
    const scale = Math.min(vw / STAGE_WIDTH, vh / STAGE_HEIGHT)
    const offsetX = Math.round((vw - STAGE_WIDTH * scale) / 2)
    const offsetY = Math.round((vh - STAGE_HEIGHT * scale) / 2)

    stage.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`
    document.documentElement.style.setProperty('--stage-scale', String(scale))
  }

  apply()
  window.addEventListener('resize', apply)
  window.addEventListener('orientationchange', apply)

  return () => {
    window.removeEventListener('resize', apply)
    window.removeEventListener('orientationchange', apply)
  }
}
